// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pending-order-pop {
  0% { transform: scale(1); }
  32% { transform: scale(1.35) rotate(-5deg); }
  58% { transform: scale(0.92) rotate(2deg); }
  100% { transform: scale(1); }
}

.pending-order-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform-origin: center;
}

.pending-order-badge--updated {
  animation: pending-order-pop 650ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@media (prefers-reduced-motion: reduce) {
  .pending-order-badge--updated { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/layout/header/pendingOrderBadge.css"],"names":[],"mappings":"AAAA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,oCAAoC,EAAE;EAC5C,MAAM,mCAAmC,EAAE;EAC3C,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,gCAAgC,eAAe,EAAE;AACnD","sourcesContent":["@keyframes pending-order-pop {\n  0% { transform: scale(1); }\n  32% { transform: scale(1.35) rotate(-5deg); }\n  58% { transform: scale(0.92) rotate(2deg); }\n  100% { transform: scale(1); }\n}\n\n.pending-order-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transform-origin: center;\n}\n\n.pending-order-badge--updated {\n  animation: pending-order-pop 650ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pending-order-badge--updated { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
